import { render, staticRenderFns } from "./RisksProject.vue?vue&type=template&id=61621af6&"
import script from "./RisksProject.vue?vue&type=script&lang=js&"
export * from "./RisksProject.vue?vue&type=script&lang=js&"
import style0 from "./RisksProject.vue?vue&type=style&index=0&id=61621af6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports